// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"12":"make","18":"product","443":"about"}[chunkId] + "." + {"12":"4a717a5d","18":"d608a47f","443":"2a8c23ca"}[chunkId] + ".js";
};